import { render, staticRenderFns } from "./StpsndOpts.vue?vue&type=template&id=52ecc653&scoped=true"
import script from "./StpsndOpts.vue?vue&type=script&lang=js"
export * from "./StpsndOpts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecc653",
  null
  
)

export default component.exports